import React, { useState } from 'react';
import axios from 'axios';
import { Notification_Url } from './Components/Api/ApiUrls';

const SendNotificationForm = () => {
  const [token, setToken] = useState('');
  const [title, setTitle] = useState('Hello');
  const [body, setBody] = useState('This is a test notification');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      alert("Please enter the FCM token.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${Notification_Url}/send-notification`, {
        token,
        title,
        body,
      });
      setResponse(res.data);
    } catch (err) {
      console.error('Error sending notification:', err);
      setResponse({
        success: false,
        message: 'Failed to send notification',
        error: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
      <h2>Send FCM Notification</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>FCM Token:</label><br />
          <textarea
            rows="4"
            cols="50"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Paste FCM token here"
            required
          />
        </div>
        <div>
          <label>Title:</label><br />
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Notification Title"
          />
        </div>
        <div>
          <label>Body:</label><br />
          <input
            type="text"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Notification Body"
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Notification'}
        </button>
      </form>

      {response && (
        <div style={{ marginTop: '20px' }}>
          <h4>Response:</h4>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default SendNotificationForm;
